<template>
  <pt-order-form class="pt-order-form__page"></pt-order-form>
</template>

<script>
import PtOrderForm from 'cps/goods-order/pt-order-form/withData'
export default {
  name: 'pt-order-form__view',
  components: {
    'pt-order-form': PtOrderForm
  }
}
</script>
